<!-- Twenty dots, filled in proportion to the chance the ticket lands. The dots
     are decoration for the eye; the sentence under them is the information,
     so they are hidden from the accessibility tree and the words are not.
     Spans throughout, because on Today this sits inside a <button>. -->
<template>
  <span class="chance">
    <span class="dots" aria-hidden="true">
      <span v-for="i in TOTAL" :key="i" class="dot" :class="{ filled: i <= filled }" />
    </span>
    <span class="chance-text">{{ oneIn(probability) }}</span>
  </span>
</template>

<script setup>
import { computed } from 'vue';
import { oneIn } from '../lib/format.js';

const props = defineProps({
  probability: { type: Number, default: null },
});

const TOTAL = 20;
const filled = computed(() => {
  const p = props.probability;
  if (p === null || Number.isNaN(p)) return 0;
  return Math.max(0, Math.min(TOTAL, Math.round(p * TOTAL)));
});
</script>

<style scoped>
.chance {
  display: block;
  margin: var(--sp-3) 0 var(--sp-1);
}
.dots {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
/* The ring is `--carbon-faint` (5.04:1) rather than `--rule` (1.47:1): twenty
   dots of which four are filled only reads as a proportion if the sixteen
   empty ones are visible, and at 8px in the rule colour they were not. The
   sentence under them is still the information — these are aria-hidden — so
   this is polish rather than a failure, but it is the difference between a
   picture and a smudge on a bright screen. */
.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 1px solid var(--carbon-faint);
  background: transparent;
}
/* `--tier-ink` is set by the ticket from its tier. */
.dot.filled {
  background: var(--tier-ink);
  border-color: var(--tier-ink);
}
.chance-text {
  display: block;
  margin-top: 6px;
  font: 500 var(--fs-meta) / 1.3 var(--font-body);
  color: var(--carbon);
}
</style>
